export const CONTAINERS = [
    'dinf',
    'edts',
    'enca',
    'encv',
    'grpl',
    'mdia',
    'meco',
    'meta',
    'mfra',
    'minf',
    'moof',
    'moov',
    'mvex',
    'prsl',
    'schi',
    'sinf',
    'stbl',
    'strk',
    'traf',
    'trak',
    'tref',
    'udta',
    'vttc',
];
//# sourceMappingURL=CONTAINERS.js.map